export function setLoadingBtn(e) {
    const target = e.target;
    target.classList.toggle('btn-loading-now');
    target.setAttribute('disabled', 'disabled');
}
export function resetLoadingBtns() {
    const loadingBtns = document.getElementsByClassName('btn-loading-now');
    for (let i = 0; i < loadingBtns.length; i++) {
        loadingBtns[i].removeAttribute('disabled');
        loadingBtns[i].classList.remove('btn-loading-now');
    }
}
